module.exports = __webpack_public_path__ + "img/XSYD.4c1eb4c4.png";